module.exports = __webpack_public_path__ + "assets/mediaemb.7f58a587.svg";